export class CreateFrankliEmailClickDto {
  constructor(
    public token: string
  ) { }
}
